module.exports = __webpack_public_path__ + "static/media/YM11_4.22e00192.jpg";